import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../auth/AuthContext'
import { Role } from '../../data/types/medico.types'
import { useEffect } from 'react'

 
 
export const DashboardPage = () => {
	const navigate = useNavigate()
	const { role } = useAuth()

	useEffect(() => {
		if (role === Role.ADMIN) {
			navigate('/med/admin/medicos')
		} else if (role === Role.MEDICO) {
			navigate('/med/calendario')
		}
	}, [])

	return (
		<div>...</div>
	)
}